import { DeepPartial } from '../../../types';
import { ProjectSection, ProjectSectionId } from '../../domain/Project';
import { unsetProjectModalToDisplay } from '../../legacy/actions/modals';
import { createCommand } from '../../utils';
import { currentProjectIdQuery } from '../queries';
import { moduleName, updatedProjectSections } from '../state';

interface EditProjectSectionsParams {
    projectSectionIds: ProjectSectionId[];
    projectSectionData: DeepPartial<ProjectSection>;
}

const editProjectSections = createCommand(
    `${moduleName}/EDIT_PROJECT_SECTIONS`,
    async ({ projectSectionData, projectSectionIds }: EditProjectSectionsParams, { dispatch, extra, getState }) => {
        try {
            const state = getState();
            const projectId = currentProjectIdQuery(state);

            if (!projectId) {
                throw new Error('No project selected');
            }

            const updatedSections = await extra.externalProject.editProjectSections(
                projectSectionIds,
                projectId,
                projectSectionData,
            );

            dispatch(updatedProjectSections(updatedSections));
            dispatch(unsetProjectModalToDisplay());
        } catch (err) {
            // TODO: Handle errors properly
            console.error('Error editing project sections:', err);
            throw err;
        }
    },
);

export default editProjectSections;
